<template>
  <div class="meeting-bill-select-dialog">
    <el-dialog
      :title="title"
      :visible="visible"
      :before-close="beforeCloseHandler"
    >
      <div>
        <el-form :model="queryForm" label-width="100px">
          <el-row>
            <el-col :span="12">
              <el-form-item label="议题：">
                <el-input
                  placeholder="模糊查询"
                  v-model="queryForm.search"
                  clearable
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item>
                <div class="search-btns">
                  <el-button type="primary" icon @click="handleSearch"
                    >查询</el-button
                  >
                  <el-button type="info" icon @click="resetSearch"
                    >重置</el-button
                  >
                </div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div style="padding-bottom: 10px">
        <el-tabs :value="activeKey" @tab-click="changeTab">
          <el-tab-pane
            v-for="tab in tabs"
            :key="tab.value"
            :label="tab.label"
            :name="tab.value"
          ></el-tab-pane>
        </el-tabs>
      </div>
      <div>
        <el-table
          class="my-table"
          ref="tableRef"
          :data="meetingBillList"
          border
          @selection-change="handleSelectionChange"
          @row-click="rowClicked"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            v-for="(item, index) in tableProps"
            :key="index"
            :prop="item.prop"
            :label="item.label"
          ></el-table-column>
          <el-table-column label="参会部门" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-for="item in scope.row.checkWorkList" :key="item.id">
                {{ item.name }}&nbsp;
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="my-page">
        <span style="color: #666666; font-size: 14px; display: block"
          >显示{{
            totalCount > 0
              ? (currentPage - 1) * pageSize +
                1 +
                "-" +
                (currentPage * pageSize > totalCount
                  ? totalCount
                  : currentPage * pageSize)
              : "0"
          }}，共{{ totalCount }}条记录</span
        >
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalCount"
        ></el-pagination>
      </div>
      <div slot="footer">
        <el-button @click="closeDialog" type="info">取消</el-button>
        <el-button type="primary" @click="submitDialog">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * dialog选择提报单，不从父组件传数据进来了，就是最后submit的时候，把选到的提报单列表发出去
 * 在父组件那里接收到之后，去重，作为最后选定的提报单
 */
import { getDeclarationList } from "@/services/declarationServices";
import Constants from "@/utils/consts";
import _ from "lodash"
export default {
  name: "MeetingBillSelectDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title: "选择提报单",
      currentPage: 1,
      pageSize: 10,
      meetingBillList: [], //当前页码的提报单
      meetingBillSelectedItems: [], // 选定的提报单列表
      tableProps: [
        { prop: "title", label: "议题" },
        { prop: "reportUserName", label: "汇报人" },
      ],
      totalCount: 0,
      queryForm: {
        search: "", //模糊查询
      },
      activeKey: "second",
      tabs: [
        // {
        //   label: "全部",
        //   value: "first",
        // },
        {
          label: "未上会",
          value: "second",
        },
        // {
        //   label: "已上会",
        //   value: "third",
        // },
      ],
    };
  },
  mounted() {
    console.log("选提报单dialog mounted");
    // this.getList();
  },
  watch: {
    visible:function(newvalue, oldvalue) {
      console.log("---visible", newvalue)
      if(newvalue) {
        this.getList()
      }
    }
  },
  methods: {
    handleSearch() {
      this.getList();
    },
    resetSearch() {
      this.currentPage = 1;
      this.queryForm.search = "";
      this.getList();
    },
    changeTab(tab) {
      console.log("changeTab", tab);
      this.activeKey = tab.name
      this.resetSearch();
    },
    getList() {
      let params = {
        approveStatus: 3, // 已通过的
        submitStatus: 0,
        tabIndex: 99, // 写死99
        pageIndex: this.currentPage,
        pageSize: this.pageSize,
        title: this.queryForm.search,
      };
      if(this.activeKey == 'first') {
        params.submitStatus = null
      } else if(this.activeKey == 'second') {
        params.submitStatus = 0
      } else if(this.activeKey == 'third') {
        params.submitStatus = 1
      }
      console.log("getList参数", params, this.activeKey);
      // 通过approveStatus和tabIndex筛选出可以选择的提报单
      getDeclarationList(params)
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            let list = res.data || [];
            list.forEach((item) => {
              try {
                item.checkWorkList = JSON.parse(item.checkWorkJson);
              } catch (error) {
                console.log("解析提报单参会部门数据错误。", error.message);
              }
            });
            this.meetingBillList = list;
            this.totalCount = res.total || 0;
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {});
    },
    handleSelectionChange(val) {
      this.meetingBillSelectedItems = val;
    },
    rowClicked(row, event, column) {
      this.$refs.tableRef.toggleRowSelection(row);
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    closeDialog() {
      this.$emit("submit");
    },
    submitDialog() {
      console.log(">>> 选定提报单的数据\n", this.meetingBillSelectedItems);
      let deep = _.cloneDeep(this.meetingBillSelectedItems)
      this.$emit("submit", deep);
      this.$refs.tableRef.clearSelection();
      
    },
    beforeCloseHandler(done) {
      done();
      this.$emit("submit");
    },
  },
};
</script>

<style lang="scss" scoped>
.my-page {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
}

.my-table {
  width: 100%;
  min-height: 300px;
}

.el-pagination {
  padding-top: 0;
  padding-bottom: 0;
}

.search-btns {
  display: flex;
}
</style>
